<template>
  <v-dialog :value="true" persistent max-width="720" content-class="firma-entrega-dialog">
    <section class="firma-entrega" role="dialog" aria-modal="true" aria-labelledby="firma-entrega-titulo">
      <header>
        <div><h2 id="firma-entrega-titulo">Firma del destinatario</h2><p>{{ numeroEnvio }}</p></div>
        <button type="button" title="Cancelar firma" aria-label="Cancelar firma" @click="$emit('cancelar')"><i class="fa fa-times" aria-hidden="true"></i></button>
      </header>
      <canvas ref="lienzo" width="1000" height="360" aria-label="Firma del destinatario" tabindex="0"
        @pointerdown.prevent="iniciar" @pointermove.prevent="dibujar" @pointerup.prevent="terminar"
        @pointercancel="terminar" @lostpointercapture="terminar"></canvas>
      <p v-if="error || mensaje" class="firma-error" role="alert">{{ error || mensaje }}</p>
      <footer>
        <button type="button" title="Borrar firma" aria-label="Borrar firma" @click="limpiar"><i class="fa fa-eraser" aria-hidden="true"></i></button>
        <span></span>
        <button type="button" @click="$emit('cancelar')">Cancelar</button>
        <button type="button" class="firma-confirmar" :disabled="!tieneTrazo || puntero !== null" @click="confirmar"><i class="fa fa-check" aria-hidden="true"></i> Confirmar entrega</button>
      </footer>
    </section>
  </v-dialog>
</template>

<script>
export default {
  name: 'FirmaEntrega',
  props: { numeroEnvio: { type: String, required: true }, mensaje: { type: String, default: '' } },
  data: () => ({ puntero: null, ultimo: null, distancia: 0, tieneTrazo: false, error: '' }),
  mounted() { this.$nextTick(() => { this.limpiar(); this.$refs.lienzo.focus(); }); },
  methods: {
    limpiar() {
      const canvas = this.$refs.lienzo, ctx = canvas.getContext('2d');
      ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.strokeStyle = '#171717'; ctx.lineWidth = 3; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      this.puntero = null; this.ultimo = null; this.distancia = 0; this.tieneTrazo = false; this.error = '';
    },
    punto(event) {
      const canvas = this.$refs.lienzo, rect = canvas.getBoundingClientRect();
      return { x: Math.max(0, Math.min(canvas.width, (event.clientX - rect.left) * canvas.width / rect.width)),
        y: Math.max(0, Math.min(canvas.height, (event.clientY - rect.top) * canvas.height / rect.height)) };
    },
    iniciar(event) {
      if (this.puntero !== null || event.button !== 0) return;
      this.puntero = event.pointerId; this.ultimo = this.punto(event); this.error = '';
      this.$refs.lienzo.setPointerCapture(event.pointerId);
    },
    dibujar(event) {
      if (event.pointerId !== this.puntero) return;
      const punto = this.punto(event), ctx = this.$refs.lienzo.getContext('2d');
      ctx.beginPath(); ctx.moveTo(this.ultimo.x, this.ultimo.y); ctx.lineTo(punto.x, punto.y); ctx.stroke();
      this.distancia += Math.hypot(punto.x - this.ultimo.x, punto.y - this.ultimo.y);
      this.tieneTrazo = this.distancia >= 12; this.ultimo = punto;
    },
    terminar(event) { if (event.pointerId === this.puntero) { this.puntero = null; this.ultimo = null; } },
    confirmar() {
      if (!this.tieneTrazo || this.puntero !== null) { this.error = 'Debe capturar la firma del destinatario.'; return; }
      this.$emit('confirmar', this.$refs.lienzo.toDataURL('image/png'));
    },
  },
};
</script>

<style scoped>
.firma-entrega { background: #fff; color: #202b33; padding: 18px; }
.firma-entrega header, .firma-entrega footer { display: flex; align-items: center; gap: 12px; }
.firma-entrega header { justify-content: space-between; margin-bottom: 14px; }
.firma-entrega h2 { font-size: 18px; line-height: 1.4; margin: 0; letter-spacing: 0; }
.firma-entrega p { margin: 4px 0 0; overflow-wrap: anywhere; }
.firma-entrega header > div { min-width: 0; }
.firma-entrega canvas { display: block; width: 100%; height: auto; aspect-ratio: 25 / 9; border: 1px solid #738998; background: #fff; touch-action: none; }
.firma-entrega footer { margin-top: 16px; flex-wrap: wrap; }
.firma-entrega footer span { flex: 1; }
.firma-entrega button { min-height: 40px; min-width: 40px; padding: 8px 12px; border: 1px solid #a5b3bc; border-radius: 3px; font-size: 14px; }
.firma-entrega .firma-confirmar { background: #416d8f; border-color: #416d8f; color: #fff; }
.firma-entrega button:disabled { opacity: .45; cursor: default; }
.firma-entrega button:focus-visible, .firma-entrega canvas:focus-visible { outline: 2px solid #1d7abb; outline-offset: 2px; }
.firma-entrega .firma-error { color: #a22f2f; font-size: 14px; }
@media (max-width: 480px) { .firma-entrega { padding: 12px; } .firma-entrega footer { gap: 8px; } }
</style>
